<template>
  <div>
    <page-header
      :actions="availableActions"
      :on-return="() => goBack()"
      :page="page"
    />
    <div v-if="addingDocument">
      <section-title
        bg-icon="green"
        icon="fas fa-file-plus"
        title="Añadir Documento"
        title-class="tag-badge-main-info mt-2 mb-2"
      />
      <validation-observer ref="formValidator">
        <div v-if="isForInterventionPlan" class="col-12 mt-4 pl-4">
          <div class="col-12 pt-0">
            <strong class="d-block">Proveedor:</strong>
            <span style="font-weight:100">{{ this.providerName }}</span>
          </div>
        </div>
        <div class="gray-box row my-4 p-4 ml-1 align-items-start">
          <div
            v-if="isForInterventionPlan"
            class="col-md-3 col-4 col-xs-12 pt-0"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Año Académico"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedAcademicYearIP"
                custom-error-msg="Favor de seleccionar el año académico."
                :error="errors[0]"
                fieldkey="id"
                fieldname="description"
                label="Año Académico:"
                :options="academicYearListIP"
                placeholder="Seleccionar"
                required
                @input="onChangeAcademicYearIP"
              />
            </validation-provider>
          </div>
          <div v-if="isForInterventionPlan" class="col-md-3 col-4 pt-0">
            <validation-provider
              v-slot="{ errors }"
              name="Documento Plan Academico"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedDocumentTypeIP"
                custom-error-msg="Favor de seleccionar el tipo de documento."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Documento:"
                :options="documentTypeListIP"
                placeholder="Seleccionar"
                @input="onChangeDocumentIP"
              />
            </validation-provider>
          </div>
          <div v-if="!isForInterventionPlan" class="col-md-3 col-6 pt-0">
            <validation-provider
              v-slot="{ errors }"
              name="Documento"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedDocumentType"
                custom-error-msg="Favor de seleccionar el tipo de documento."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Documento:"
                :options="documentTypeList"
                placeholder="Seleccionar"
                required
              />
            </validation-provider>
          </div>
          <div class="col-md-6 col-4">
            <validation-provider
              v-slot="{ errors }"
              name="Archivo"
              rules="required"
            >
              <custom-file-input
                ref="attachedDocument"
                v-model="selectedDocument"
                :accept="allowedFiles"
                custom-error-msg="Favor de anejar el documento."
                display-style="normal"
                :error="errors[0]"
                label="Archivo:"
                label-position="left"
                required
              />
            </validation-provider>
          </div>
          <div
            v-if="!isForInterventionPlan"
            class="col-sm-12 col-md-3 pt-0 buttons-container justify-content-end d-flex"
          >
            <action-button
              i="fas fa-times-circle"
              min-width="124px"
              variant="outline-danger mr-2"
              @click="cancelAddDocument"
            >
              Cancelar
            </action-button>
            <action-button
              i="fas fa-save"
              min-width="124px"
              variant="success"
              @click="saveDocument"
            >
              Guardar
            </action-button>
          </div>
        </div>
        <div
          v-if="
            isForInterventionPlan &&
              selectedDocumentIpId &&
              selectedDocumentIpId !=
                thrpyDocumentTypesCodes.ResumenResultadoDeServicios &&
              selectedDocumentIpId != thrpyDocumentTypesCodes.PlanDeEnmienda
          "
          class="gray-box row my-4 p-4 ml-1 align-items-start mt-n3"
        >
          <div v-if="isBillingDiscussionPlanVisible" class="col-md-3">
            <validation-provider
              v-slot="{ errors }"
              name="Fecha del Plan"
              rules="required"
            >
              <div>
                <strong class="billing-text-label">
                  ¿Estará facturando la discusión del plan?
                </strong>
                <custom-radio-group
                  v-model="selectedbillingDiscussionIP"
                  custom-error-msg="Favor de seleccionar si el plan fue discutido con el encargado."
                  :error="errors[0]"
                  :is-inline="true"
                  name="billingDiscussionPlan"
                  :options="radioButtonsOptions"
                  @input="onSelectedBillingDisussionPlan"
                />
              </div>
            </validation-provider>
          </div>
          <div v-if="isDateAndTimeVisible" class="col-md-3">
            <validation-provider
              v-slot="{ errors }"
              name="Fecha del Plan"
              rules="required"
            >
              <custom-date-picker
                v-model="planDate"
                :custom-error-msg="
                  'Favor de seleccionar la fecha de discusión.'
                "
                :error="errors[0]"
                label="Fecha del Plan:"
                :max-date="new Date()"
              />
            </validation-provider>
          </div>
          <div v-if="isDateAndTimeVisible" class="col-md-3 col-sm-6">
            <div class="d-flex flex-row">
              <validation-provider
                v-slot="{ errors }"
                class="mr-5"
                name="Hora"
                rules="required"
              >
                <custom-time-picker
                  v-model="startTime"
                  :custom-error-msg="
                    'Favor de seleccionar la hora desde de la discusión.'
                  "
                  :error="errors[0]"
                  label="Hora Desde:"
                  @change="setStartTime"
                />
              </validation-provider>
              <validation-provider
                v-slot="{ errors }"
                name="Hora Hasta"
                rules="required"
              >
                <custom-time-picker
                  v-model="endTime"
                  :custom-error-msg="
                    'Favor de seleccionar la hora hasta de la discusión.'
                  "
                  :error="errors[0]"
                  label="Hora Hasta:"
                  @change="setEndTime"
                />
              </validation-provider>
            </div>
          </div>
        </div>
        <div
          v-if="isForInterventionPlan"
          class="col-12 buttons-container justify-content-end d-flex"
        >
          <action-button
            i="fas fa-times-circle"
            min-width="124px"
            variant="outline-danger mr-2"
            @click="cancelAddDocument"
          >
            Cancelar
          </action-button>
          <action-button
            i="fas fa-save"
            min-width="124px"
            variant="success"
            @click="saveDocument"
          >
            Guardar
          </action-button>
        </div>
      </validation-observer>
    </div>
    <div
      v-if="
        documentsCounter > 0 ||
          resultSummary != null ||
          achievementSummary != null
      "
    >
      <div
        v-for="item in academicYearIdList"
        :key="item.yearId"
        class="m-3 container-design"
      >
        <div class="w-100">
          <em
            v-if="!item.isOpen"
            class="fas fa-plus-circle rounded-circle shadow color-icon-plus custom-design"
            @click="item.isOpen = true"
          />
          <em
            v-else
            class="fas fa-minus-circle rounded-circle shadow text-orange custom-design"
            @click="item.isOpen = false"
          />
          <span class="pl-2">
            {{
              item.yearId != 0
                ? item.academicYearDescription
                : 'Sin año academico'
            }}
          </span>
          <br />
        </div>
        <div v-if="item.isOpen" class="ml-4 mt-4">
          <div
            v-for="documentType in documentsByType"
            :key="documentType.id + documentType.name + item.yearId"
          >
            <div
              v-if="
                documentType.docs?.filter(
                  (x) => x.academicYearId == item.yearId
                ) &&
                  documentType.docs?.filter(
                    (x) => x.academicYearId == item.yearId
                  ).length > 0
              "
            >
              <section-title
                :bg-icon="
                  getBgIcon(
                    isTypeVisible(
                      documentType.id + documentType.name + item.yearId
                    )
                  )
                "
                class="cursor-pointer"
                :icon="
                  getIcon(
                    isTypeVisible(
                      documentType.id + documentType.name + item.yearId
                    )
                  )
                "
                :title="documentType.name"
                title-class="tag-badge-main-info mt-2 mb-2 bg-transparent"
                @on-click="
                  toggleVisibility(
                    documentType.id + documentType.name + item.yearId
                  )
                "
              />
              <transition name="list">
                <div
                  v-show="
                    isTypeVisible(
                      documentType.id + documentType.name + item.yearId
                    )
                  "
                  class="card-body p-0 mb-4"
                >
                  <div
                    v-for="(card, cardIndex) in documentType.docs"
                    :key="cardIndex"
                  >
                    <row-card-item-card
                      v-if="card.academicYearId == item.yearId"
                      :container-bg-white="true"
                      status-class="gray"
                    >
                      <div slot="body">
                        <div class="col-12 p-0 d-flex">
                          <div class="pl-0 py-0 col-5">
                            <div class="d-flex flex-column">
                              <span class="data-title">Título:</span>
                              <span class="data-content">
                                {{ card.documentTitle }}
                              </span>
                            </div>
                          </div>
                          <div
                            v-if="
                              documentType.id ==
                                thrpyDocumentTypesCodes.PlanDeIntervencion
                            "
                            class="d-flex align-items-start flex-fill"
                          >
                            <div class="d-flex flex-column">
                              <span class="data-title">
                                ¿Estará facturando la discusión del plan?
                              </span>
                              <span class="data-content">
                                {{
                                  card.planDiscussedWithParentsFlag
                                    ? 'SI'
                                    : 'NO'
                                }}
                              </span>
                            </div>
                          </div>
                          <div
                            v-if="card.planProductionDate"
                            class="d-flex align-items-start flex-fill"
                          >
                            <div class="d-flex flex-column">
                              <span class="data-title">Fecha de Plan:</span>
                              <span class="data-content">
                                {{ card.planProductionDate | date }}
                              </span>
                            </div>
                          </div>
                          <div
                            v-if="card.completeTime"
                            class="d-flex align-items-start flex-fill"
                          >
                            <div class="d-flex flex-column">
                              <span class="data-title">Hora:</span>
                              <span class="data-content ml-1 cursor-pointer">
                                {{ card.completeTime }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div slot="actions">
                        <div class="dropdown text-right">
                          <button
                            aria-expanded="false"
                            aria-haspopup="true"
                            class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                            data-toggle="dropdown"
                          >
                            <span class="px-2">Acciones</span>
                            <i class="fa fa-angle-down" />
                          </button>
                          <div
                            class="dropdown-menu dropdown-menu-right py-2 mt-1"
                          >
                            <div
                              class="dropdown-item"
                              @click="downloadDocument(documentType.id, card)"
                            >
                              <em class="fa fa-download text-green pr-1" />
                              <span>Descargar Documento</span>
                            </div>
                            <div
                              v-if="showReplacement(documentType.id, card)"
                              class="dropdown-item"
                              @click="replaceDocument(documentType.id, card)"
                            >
                              <em class="fa fa-copy text-green pr-1" />
                              <span>Reemplazar Documento</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </row-card-item-card>
                  </div>
                  <div
                    v-if="
                      !existDocument(
                        item.yearId,
                        documentType.name,
                        documentType.id
                      )
                    "
                  >
                    <div
                      class="d-flex align-items-center justify-content-center mt-5 py-5"
                    >
                      <div class="align-items-center d-flex">
                        <i
                          class="fal big-icon mr-4 fa-folder-open text-gray-light"
                        />
                        <span class="text-gray-light message">
                          No existen documentos
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <!-- Resumen de Logros -->
          <div v-if="achievementSummary != null">
            <section-title
              :bg-icon="getBgIcon(isTypeVisible('achievementSummary'))"
              class="cursor-pointer"
              :icon="getIcon(isTypeVisible('achievementSummary'))"
              title="Resumen de Logros"
              title-class="tag-badge-main-info mt-2 mb-2 bg-transparent"
              @on-click="toggleVisibility('achievementSummary')"
            />
            <transition name="list">
              <div
                v-show="isTypeVisible('achievementSummary')"
                class="card-body p-0 mb-4"
              >
                <div>
                  <row-card-item-card
                    :container-bg-white="true"
                    status-class="gray"
                  >
                    <div slot="body">
                      <div class="col-12 p-0 d-flex">
                        <div class="pl-0 py-0 col-5">
                          <div class="d-flex flex-column">
                            <span class="data-title">Título:</span>
                            <span class="data-content">
                              Resumen de Logros
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="actions">
                      <div class="dropdown text-right">
                        <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                          data-toggle="dropdown"
                        >
                          <span class="px-2">Acciones</span>
                          <i class="fa fa-angle-down" />
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-right py-2 mt-1"
                        >
                          <div
                            class="dropdown-item"
                            @click="downloadDocument('achievementSummary')"
                          >
                            <em class="fa fa-download text-green pr-1" />
                            <span>Descargar Documento</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </row-card-item-card>
                  <div
                    v-for="documentType in summaryAchievements"
                    :key="documentType.id + documentType.name + item.yearId"
                  >
                    <div
                      v-for="card in documentType.docs"
                      :key="card.documentId"
                    >
                      <RowCardItemCard
                        v-if="card.academicYearId == item.yearId"
                        :container-bg-white="true"
                        status-class="gray"
                      >
                        <!-- Cuerpo de la Card -->
                        <div slot="body">
                          <div class="col-12 p-0 d-flex">
                            <div
                              class="pl-0 py-0"
                              :class="{
                                'col-md-5 col-sm-12':
                                  documentType.id ==
                                  thrpyDocumentTypesCodes.PlanDeIntervencion,
                                'col-md-5 col-sm-12':
                                  documentType.id !=
                                  thrpyDocumentTypesCodes.PlanDeIntervencion,
                              }"
                            >
                              <div class="d-flex flex-column">
                                <span class="data-title">Título:</span>
                                <span class="data-content">
                                  {{ card.documentTitle }}
                                </span>
                              </div>
                            </div>
                            <div
                              v-if="
                                documentType.id ==
                                  thrpyDocumentTypesCodes.PlanDeIntervencion
                              "
                              class=" ml-5 d-flex align-items-start flex-fill"
                            >
                              <div class="d-flex flex-column">
                                <span class="data-title">
                                  ¿Estará facturando la discusión del plan?
                                </span>
                                <span class="data-content">
                                  {{
                                    card.planDiscussedWithParentsFlag
                                      ? 'SI'
                                      : 'NO'
                                  }}
                                </span>
                              </div>
                            </div>
                            <div
                              v-if="card.planProductionDate"
                              class="d-flex align-items-start flex-fill"
                            >
                              <div class="d-flex flex-column">
                                <span class="data-title">Fecha de Plan:</span>
                                <span class="data-content">
                                  {{ card.planProductionDate | dateFormat }}
                                </span>
                              </div>
                            </div>
                            <div
                              v-if="card.completeTime"
                              class="d-flex align-items-start flex-fill"
                            >
                              <div class="d-flex flex-column">
                                <span class="data-title">Hora:</span>
                                <span class="data-content ml-1 cursor-pointer">
                                  {{ card.completeTime }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div slot="actions">
                          <div class="dropdown text-right">
                            <button
                              aria-expanded="false"
                              aria-haspopup="true"
                              class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                              data-toggle="dropdown"
                            >
                              <span class="px-2">Acciones</span>
                              <i class="fa fa-angle-down" />
                            </button>
                            <div
                              class="dropdown-menu dropdown-menu-right py-2 mt-1"
                            >
                              <div
                                class="dropdown-item"
                                @click="downloadDocument(documentType.id, card)"
                              >
                                <em class="fa fa-download text-green pr-1" />
                                <span>Descargar Documento</span>
                              </div>
                              <div
                                v-if="
                                  hasReplaceDocPermission && canReplaceDoc(card)
                                "
                                class="dropdown-item"
                                @click="replaceDocument(card)"
                              >
                                <em class="fa fa-copy text-green pr-1" />
                                <span>Reemplazar Documento</span>
                              </div>
                              <div
                                v-if="
                                  (isInterventionPlanDoc(card) &&
                                    interventionPlanDocs.length > 1 &&
                                    canBeDeleted(card)) ||
                                    canBeDeleted(card)
                                "
                                class="dropdown-item"
                                @click="
                                  deleteDocument(
                                    card,
                                    documentType.id + documentType.name
                                  )
                                "
                              >
                                <em class="fa fa-trash text-red pr-1" />
                                <span>Eliminar Documento</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </RowCardItemCard>
                    </div>
                    <div
                      v-if="
                        !existDocumentInSummary(
                          item.yearId,
                          documentType.name,
                          documentType.id
                        )
                      "
                    >
                      <div
                        class="d-flex align-items-center justify-content-center mt-5 py-5"
                      >
                        <div class="align-items-center d-flex">
                          <i
                            class="fal big-icon mr-4 fa-folder-open text-gray-light"
                          />
                          <span class="text-gray-light message">
                            No existen documentos
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <!-- Resumen de Resultados -->
          <div v-if="resultSummary != null">
            <section-title
              :bg-icon="getBgIcon(isTypeVisible('resultSummary'))"
              class="cursor-pointer"
              :icon="getIcon(isTypeVisible('resultSummary'))"
              title="Resumen de Resultados"
              title-class="tag-badge-main-info mt-2 mb-2 bg-transparent"
              @on-click="toggleVisibility('resultSummary')"
            />
            <transition name="list">
              <div
                v-show="isTypeVisible('resultSummary')"
                class="card-body p-0 mb-4"
              >
                <div>
                  <row-card-item-card status-class="gray">
                    <div slot="body">
                      <div class="col-12 p-0 d-flex">
                        <div class="pl-0 py-0 col-5">
                          <div class="d-flex flex-column">
                            <span class="data-title">Título:</span>
                            <span class="data-content">
                              Resumen de Resultados
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="actions">
                      <div class="dropdown text-right">
                        <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                          data-toggle="dropdown"
                        >
                          <span class="px-2">Acciones</span>
                          <i class="fa fa-angle-down" />
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-right py-2 mt-1"
                        >
                          <div
                            class="dropdown-item"
                            @click="downloadDocument('resultSummary')"
                          >
                            <em class="fa fa-download text-green pr-1" />
                            <span>Descargar Documento</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </row-card-item-card>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="d-flex align-items-center justify-content-center mt-5 py-5">
        <div class="align-items-center d-flex">
          <i class="fal big-icon mr-4 fa-folder-open text-gray-light" />
          <span class="text-gray-light message">
            No existen documentos
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import RowCardItemCard from '@/components/common/rowcard/RowCardItemCard';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import CustomFileInput from '@/components/common/CustomFileInput';
import ActionButton from '@/components/common/ActionButton';
import CustomDatePicker from '@/components/common/form/CustomDatePicker';
import CustomTimePicker from '@/components/common/CustomTimePicker';
import CustomRadioGroup from '@/components/common/CustomRadio';
import alert from '@/mixins/alert.mixin';
// import generalService from "@/services/pei/general";
// import thrpyReferralService from "@/services/pei/thrpyReferrals"
// import academicYearService from "@/services/academicyear"
import DocumentTypes from '@/utils/shared/constants/documentTypes';
import moment from 'moment';

import { getEffectiveAcademyYearsForAdmission as _getEffectiveAcademyYearsForAdmission } from '@/modules/shared/academicyear.api';

import {
  getDocumentsByStudentServiceIdAndAdmissionId as _getDocumentsByStudentServiceIdAndAdmissionId,
  getValidDocumentTypes as _getValidDocumentTypes,
  downloadDocumentForThrerapyReferral as _downloadDocumentForThrerapyReferral,
  downloadDocumentForRP as _downloadDocumentForRP,
  saveInterventionPlanDocument as _saveInterventionPlanDocument,
  saveThrpyReferralItemAttachment as _saveThrpyReferralItemAttachment,
  therapyDocTypeOther as _therapyDocTypeOther,
  updateReferralItemAttachment as _updateReferralItemAttachment,
} from '@/modules/shared/studentreferral.api';

import { getProviderName as _getProviderName } from '@/modules/shared/provider.api';

import _generalApi from '@/modules/app/api.js';
const peiDocumentType = Object.freeze({
  Minuta: 857,
  _Minuta: 76,
  InformeAltaBaja: 1870,
  _InformeAltaBaja: 100,
  Evaluacion: 856,
  _Evaluacion: 75,
  Otro: 858,
  _Otro: 77,
  _InformeAltaBajaSAEE06: 100,
});
const PLAN_INTERVENCION_FIRMADO = 'Plan de Intervención Firmado';
const HOJA_TRAMITE_SAEE = 'Hoja de Trámite (SEE-UMESR-CSEE-VC-07)';
export default {
  name: 'ServiceHistoryDocuments',
  components: {
    RowCardItemCard,
    SectionTitle,
    CustomDropDown,
    CustomFileInput,
    ActionButton,
    CustomDatePicker,
    CustomTimePicker,
    CustomRadioGroup,
  },
  mixins: [alert],
  props: {
    mainTitle: {
      type: String,
      default: () => '',
    },
    returnUrl: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Ver Documentos',
        routes: ['Inicio', 'Proveedor', 'Manejo de Referidos', 'Documentos'],
      },
      studentServiceId: null,
      visibleTypes: [],
      allowAddDocument: false,
      showInterventions: false,
      showMinutes: false,
      showEvaluations: false,
      showOthers: false,
      addingDocument: false,
      isInterventionPlanSubmitted: false,
      selectedDocumentType: null,
      selectedDocument: null,
      selectedDocumentTypeIP: null,
      selectedAcademicYearIP: null,
      selectedbillingDiscussionIP: null,
      planDate: null,
      endTime: null,
      startTime: null,
      allowedFiles: '.pdf',
      documentTypes: {
        PlanDeIntervencion: { id: 844, name: 'Plan de Intervención' },
        Minuta: { id: 76, name: 'Minuta' },
        Evaluacion: { id: 75, name: 'Evaluación' },
        CartaDeAprestacionDeRemedio: {
          id: -1,
          name: 'Carta de Aprestación de Remedio',
        },
        Otros: { id: 77, name: 'Otros' },
        PlanDeIntervencionRP: { id: 39, name: 'Plan de Intervención' },
        InformeDeProgresoRP: { id: 40, name: 'Informe de Progreso' },
        HojaDeAsistenciaRP: { id: 41, name: 'Hoja de Asistencia' },
        OtrosRP: { id: 37, name: 'Otros' },
      },
      documentTypeList: [],

      documentsCounter: 0,
      documentsByType: [],
      tabToReturn: null,
      routeTitle: '',
      providerName: '',
      documentTypeListIP: [],
      academicYearListIP: [],
      academicYearIdList: [],
      summaryAchievements: [],
      radioButtonsOptions: [
        { label: 'Si', value: true },
        { label: 'No', value: false },
      ],
      academicYearId: 0,
      interventionPlanId: 0,
    };
  },
  computed: {
    availableActions() {
      return [
        {
          component: 'ActionButton',
          variant: 'success',
          text: 'Anejar Documento',
          icon: 'fas fa-file-plus',
          click: this.addDocument,
          visible: this.allowAddDocument,
        },
      ];
    },
    selectedDocumentIpId() {
      return this.selectedDocumentTypeIP?.id ?? 0;
    },
    isForInterventionPlan() {
      return this.$route.params.isInterventionPlan ?? false;
    },
    isBillingDiscussionPlanVisible() {
      const selectedDocumentId = this.selectedDocumentTypeIP?.id ?? 0;

      const selectedDocument =
        selectedDocumentId == DocumentTypes.PlanDeIntervencion ||
        selectedDocumentId == DocumentTypes.PaquetePlanAnual;

      return selectedDocument;
    },
    isDateAndTimeVisible() {
      const documentId = this.selectedDocumentTypeIP?.id ?? 0;
      const hasBilling = this.selectedbillingDiscussionIP ?? false;

      if (documentId === DocumentTypes.PlanDeIntervencion && hasBilling) {
        return true;
      }
      if (documentId === DocumentTypes.PlanDeEnmienda) {
        return false;
      }
      if (documentId === DocumentTypes.PaquetePlanAnual && hasBilling) {
        return true;
      }
      if (documentId === DocumentTypes.ResumenResultadoDeServicios) {
        return false;
      }
      return false;
    },
    thrpyDocumentTypesCodes() {
      return DocumentTypes;
    },
  },
  async mounted() {
    this.studentServiceId = this.$root.$route.params.studentServiceId;
    this.allowAddDocument = this.$root.$route.params.allowAddDocument;
    this.companyId = this.$root.$route.params.companyId;
    this.admissionId = this.$root.$route.params.admissionId;
    this.resultSummary = this.$root.$route.params.resultSummary;
    this.achievementSummary = this.$root.$route.params.achievementSummary;
    this.isInterventionPlan =
      this.$root.$route.params.isInterventionPlan ?? false;
    this.academicYearId = this.$root.$route.params.academicYearId;
    this.interventionPlanId = this.$root.$route.params.interventionPlanId;
    this.isInterventionPlanSubmitted = this.$root.$route.params.isInterventionPlanSubmitted;
    await this.loadDocuments();
    await this.getThrapyDocTypeOther(this.academicYearId);

    if (this.isInterventionPlan) {
      await _getProviderName(this.companyId).then((resp) => {
        this.providerName = resp.data;
      });

      //load effective academic year
      if (this.admissionId) {
        await this.getEffectiveAcademicYears(this.admissionId);
      }
    }
  },
  methods: {
    goBack() {
      if (this.returnUrl) {
        this.$router.replace(this.returnUrl);
      } else {
        this.$router.go(-1);
      }
    },
    showReplacement(documentType, card) {
      var allowedDocuments = [
        peiDocumentType.Minuta,
        peiDocumentType._Minuta,
        peiDocumentType.Evaluacion,
        peiDocumentType._Evaluacion,
        peiDocumentType.InformeAltaBaja,
        peiDocumentType._InformeAltaBaja,
        peiDocumentType.Otro,
        peiDocumentType._Otro,
        peiDocumentType._InformeAltaBajaSAEE06,
      ];
      let showReplacement = true;
      if (
        [
          peiDocumentType.InformeAltaBaja,
          peiDocumentType._InformeAltaBaja,
        ].includes(documentType)
      ) {
        showReplacement =
          this.$route.params.showReplacement ||
          this.userHasPermissions('mipe.replace.document.bajaalta');
      }
      return (
        showReplacement &&
        allowedDocuments.includes(documentType) &&
        (this.userHasPermissions('referral.replaceitemattachment') ||
          card.isUserCreator)
      );
    },
    setStartTime(value) {
      this.startTime = value;
    },
    setEndTime(value) {
      this.endTime = value;
    },
    async replaceDocument(documentType, card) {
      let self = this;
      const confirmation = await this.ShowCancelModal(
        'Atención',
        '¿Esta seguro que desea reemplazar el documento?',
        'Aceptar',
        'Cancelar'
      );

      if (!confirmation) return;

      const inputElement = document.createElement('input');

      inputElement.setAttribute('type', 'file');
      inputElement.setAttribute('style', 'visibility:hidden');
      inputElement.setAttribute('accept', 'application/pdf');

      inputElement.onchange = async (event) => {
        const files = event.target.files;

        if (files.length === 0) return;

        const formData = new FormData();

        formData.append('Attachment', files[0]);
        formData.append('DocumentTitle', card.documentTitle);
        formData.append('FileName', files[0].name);
        formData.append('OldFileName', card.fileName);
        formData.append('StudentServiceId', this.studentServiceId);
        formData.append('DocumentTypeId', card.documentTypeId);
        formData.append('DocumentTypeCode', documentType);
        formData.append('DocumentId', card.documentId);

        _updateReferralItemAttachment(formData)
          .then(() => {
            this.ShowToast(
              'Proceso Exitoso.',
              'El documento fue reemplazado exitosamente.',
              'success'
            );
            self.loadDocuments();
          })
          .catch(({ response: errors }) => {
            this.ShowToast('', errors.data.errors.errors[0], 'error');

            return;
          });
      };

      document.body.appendChild(inputElement);
      inputElement.click();
    },
    async downloadDocument(documentType, card) {
      if (documentType == 'resultSummary') {
        let report = `referral/resultsummaryreport/${this.admissionId}/${this.resultSummary}`;
        await _generalApi.downloadReport(report);
        return;
      }
      if (documentType == 'achievementSummary') {
        let report = `referral/achievementssummaryreport/${this.admissionId}/${this.interventionPlanId}`;
        await _generalApi.downloadReport(report);
        return;
      }
      if (documentType == DocumentTypes.AdmissionNoteReport) {
        let report = `referral/admissionnotereport/${card.admissionId}`;
        await _generalApi.downloadReport(report);
        return;
      }
      if (
        documentType == DocumentTypes.PlanDeIntervencionFirmado &&
        card.isReport
      ) {
        let report = `referral/interventionplanreport/${this.admissionId}/${this.interventionPlanId}`;
        await _generalApi.downloadReport(report);
        return;
      }
      if (
        documentType == DocumentTypes.IntitialEvaluation ||
        documentType == DocumentTypes.AdditionalEvaluation
      ) {
        await _generalApi.downloadDocumentByAttachmentId(card.documentId);
        return;
      }
      if (card.documentId && this.studentServiceId) {
        await _downloadDocumentForThrerapyReferral(card.relatedRecordId).then(
          (response) => {
            _generalApi.ConvertToBlob(response.data);
          }
        );
      } else if (card.documentId && this.contractId) {
        await _downloadDocumentForRP(card.documentId).then((response) => {
          _generalApi.ConvertToBlob(response.data);
        });
      }
    },
    viewDocument() {},
    getIcon(expanded) {
      return expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right';
    },
    getBgIcon(expanded) {
      return expanded ? 'green' : 'gray';
    },
    addDocument() {
      this.addingDocument = true;
    },
    cancelAddDocument() {
      this.addingDocument = false;
      this.selectedDocumentType = null;
      this.selectedDocument = null;
    },

    async saveDocument() {
      if (this.isForInterventionPlan) {
        this.saveIntervationDocument();
      } else {
        this.saveTherapyDocument();
      }
    },
    async clearOptions() {
      this.selectedAcademicYearIP = null;
      this.isDateAndTimeVisible = false;
      this.endTime = null;
      this.startTime = null;
      this.planDate = null;
      this.selectedbillingDiscussionIP = null;
      this.selectedDocument = null;
      this.selectedDocumentTypeIP = null;
      this.documentTypeListIP = [];
    },
    async saveIntervationDocument() {
      const formValid = await this.$refs.formValidator.validate();
      if (formValid) {
        let formData = new FormData();
        formData.append('attachment', this.selectedDocument);
        formData.append('fileName', this.selectedDocument.name);
        formData.append(
          'StudentServiceId',
          this.studentServiceId ? this.studentServiceId : 0
        );
        formData.append('documentTitle', this.selectedDocument.name);
        formData.append(
          'peiAttachmentTypeCode',
          this.selectedDocumentTypeIP.id
        );
        formData.append('academicYearId', this.selectedAcademicYearIP.id);
        formData.append('admissionId', this.admissionId);
        if (this.isDateAndTimeVisible) {
          formData.append('PlanProductionEndTime', this.endTime);
          formData.append('PlanProductionStartTime', this.startTime);
          formData.append(
            'PlanProductionDate',
            moment(this.planDate).format('MM/DD/YYYY')
          );
          formData.append(
            'PlanDiscussedWithParentsFlag',
            this.selectedbillingDiscussionIP
          );
        }

        let self = this;

        await _saveInterventionPlanDocument(formData)
          .then((res) => {
            if (res) {
              this.ShowToast(
                'Proceso Exitoso',
                'El documento ha sido cargado exitosamente.',
                'success'
              );
              self.cancelAddDocument();
              self.loadDocuments();
              // Clear Options
              self.clearOptions();
            }
          })
          .catch((error) => {
            if (error && error.response && error.response.data) {
              self.ShowToast('', error.response.data.message, 'error');
            }
          });
      } else {
        this.ShowToast(
          'Error',
          'Favor de completar la información solicitada para continuar.',
          'error'
        );
      }
    },
    async saveTherapyDocument() {
      const formValid = await this.$refs.formValidator.validate();
      if (formValid) {
        let formData = new FormData();
        formData.append('attachment', this.selectedDocument);
        formData.append('fileName', this.selectedDocument.name);
        formData.append(
          'StudentServiceId',
          this.studentServiceId ? this.studentServiceId : 0
        );
        formData.append('documentTitle', this.selectedDocument.name);
        formData.append('peiAttachmentTypeCode', this.selectedDocumentType.id);

        if (this.selectedDocumentType.id === peiDocumentType._Evaluacion)
          formData.append('admissionId', this.admissionId);

        let self = this;

        await _saveThrpyReferralItemAttachment(formData)
          .then((res) => {
            if (res) {
              this.ShowToast(
                'Proceso Exitoso',
                'El documento ha sido cargado exitosamente.',
                'success'
              );
              self.cancelAddDocument();
              self.loadDocuments();
            }
          })
          .catch((error) => {
            if (error && error.response && error.response.data) {
              self.ShowToast('', error.response.data.message, 'error');
            }
          });
      } else {
        this.ShowToast(
          'Error',
          'Favor de completar la información solicitada para continuar.',
          'error'
        );
      }
    },
    async loadDocuments() {
      let self = this;
      if (self.studentServiceId) {
        await _getDocumentsByStudentServiceIdAndAdmissionId(
          self.studentServiceId,
          self.admissionId
        )
          .then((res) => {
            let documents = res.data;
            self.documentsByType = [];
            self.documentsCounter = 0;
            self.visibleTypes = [];

            let documentTypes = [];

            if (
              !documents.some(
                (x) =>
                  x.documentTypeId == DocumentTypes.PlanDeIntervencionFirmado
              ) &&
              this.isInterventionPlanSubmitted
            ) {
              documents.push({
                documentTypeId: DocumentTypes.PlanDeIntervencionFirmado,
                documentType: 'Plan de Intervención Firmado',
                documentTitle: 'InterventionPlanReport.pdf',
                isReport: true,
              });
            }
            documents.filter((value) => {
              let documenTypeModel = {
                id: value.documentTypeId,
                name: value.documentType,
              };
              if (
                documentTypes.filter((f) => f.name == documenTypeModel.name)
                  .length == 0 &&
                documenTypeModel.name != null
              ) {
                documentTypes.push(documenTypeModel);
              }
            });
            const academicYearIdsSet = new Set();

            const hasYearId = (set, yearId) => {
              for (const obj of set) {
                if (obj.yearId === yearId) {
                  return true;
                }
              }
              return false;
            };
            documents.forEach((obj) => {
              if (!hasYearId(academicYearIdsSet, obj.academicYearId)) {
                if (obj.academicYearId !== undefined) {
                  academicYearIdsSet.add({
                    yearId: obj.academicYearId,
                    isOpen: false,
                    academicYearDescription: obj.academicYearDescription,
                  });
                }
              }
            });
            this.academicYearIdList = Array.from(academicYearIdsSet);
            this.academicYearIdList.sort((a, b) => b.yearId - a.yearId);
            self.documentTypes = documentTypes;

            for (let dtype in documentTypes) {
              let filteredDocuments = [];
              filteredDocuments = documents.filter(
                (d) => d.documentType == documentTypes[dtype].name
              );

              if (
                self.documentTypes[dtype].id ==
                this.thrpyDocumentTypesCodes.PlanDeIntervencion
              ) {
                //Plan de Intervención
                filteredDocuments = documents.filter(
                  (d) =>
                    d.documentType == documentTypes[dtype].name ||
                    d.documentType == PLAN_INTERVENCION_FIRMADO
                );
              }
              if (
                self.documentTypes[dtype].id ==
                this.thrpyDocumentTypesCodes.InformeAltaBajaSAEESR06
              ) {
                //Plan de Intervención
                filteredDocuments = documents.filter(
                  (d) =>
                    d.documentType == documentTypes[dtype].name ||
                    d.documentType == HOJA_TRAMITE_SAEE
                );
              }
              if (
                self.documentTypes[dtype].id ==
                  this.thrpyDocumentTypesCodes.InformedeLogrosDiciembre ||
                self.documentTypes[dtype].id ==
                  this.thrpyDocumentTypesCodes.InformedeLogrosMayo
              ) {
                this.summaryAchievements.push({
                  id: self.documentTypes[dtype].id,
                  name: self.documentTypes[dtype].name,
                  docs: filteredDocuments,
                });
              }
              self.documentsByType.push({
                id: self.documentTypes[dtype].id,
                name: self.documentTypes[dtype].name,
                docs: filteredDocuments,
              });
              self.documentsCounter =
                documents.length * this.academicYearIdList.length;
            }
            this.documentsByType = this.documentsByType.filter(
              (item) =>
                item.name !== PLAN_INTERVENCION_FIRMADO &&
                item.name !== HOJA_TRAMITE_SAEE
            );
            const compareByName = (a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            };
            this.documentsByType = this.documentsByType.sort(compareByName);
          })
          .catch((err) => {
            this.ShowToast('Error', err.response.data.message, 'error');
          });
      }
    },
    existDocumentInSummary(yearId, name, id) {
      for (const item of this.summaryAchievements) {
        if (id == this.thrpyDocumentTypesCodes.InformeAltaBajaSAEESR06) {
          if (
            item.docs.some(
              (doc) =>
                (doc.documentType == name ||
                  doc.documentType == HOJA_TRAMITE_SAEE) &&
                doc.academicYearId === yearId
            )
          ) {
            return true;
          }
        }
        if (id == this.thrpyDocumentTypesCodes.PlanDeIntervencion) {
          if (
            item.docs.some(
              (doc) =>
                (doc.documentType == name ||
                  doc.documentType == PLAN_INTERVENCION_FIRMADO) &&
                doc.academicYearId === yearId
            )
          ) {
            return true;
          }
        }
        if (
          item.docs.some(
            (doc) => doc.documentType == name && doc.academicYearId === yearId
          )
        ) {
          return true;
        }
      }
      return false;
    },
    goToPage(page) {
      this.pagination.currentPage = page;
    },

    toggleVisibility(val) {
      let idx = this.visibleTypes.indexOf(val);
      if (idx >= 0) {
        this.visibleTypes.splice(idx, 1);
      } else {
        this.visibleTypes.push(val);
      }
    },
    isTypeVisible(id) {
      return this.visibleTypes.indexOf(id) >= 0;
    },
    existDocument(yearId, name, id) {
      for (const item of this.documentsByType) {
        if (id == this.thrpyDocumentTypesCodes.InformeAltaBajaSAEESR06) {
          if (
            item.docs.some(
              (doc) =>
                (doc.documentType == name ||
                  doc.documentType == HOJA_TRAMITE_SAEE) &&
                doc.academicYearId === yearId
            )
          ) {
            return true;
          }
        }
        if (id == this.thrpyDocumentTypesCodes.PlanDeIntervencion) {
          if (
            item.docs.some(
              (doc) =>
                (doc.documentType == name ||
                  doc.documentType == PLAN_INTERVENCION_FIRMADO) &&
                doc.academicYearId === yearId
            )
          ) {
            return true;
          }
        }
        if (
          item.docs.some(
            (doc) => doc.documentType == name && doc.academicYearId === yearId
          )
        ) {
          return true;
        }
      }
      return false;
    },
    async onChangeAcademicYearIP() {
      this.documentTypeListIP = [];
      this.selectedDocumentTypeIP = null;

      if (this.selectedAcademicYearIP) {
        await _getValidDocumentTypes(
          this.studentServiceId,
          this.selectedAcademicYearIP.id
        ).then((resp) => {
          if (resp.data) {
            this.documentTypeListIP = resp.data;
            this.selectedbillingDiscussionIP = null;
          }
        });
      }
    },
    onChangeDocumentIP() {
      this.selectedbillingDiscussionIP = null;
    },
    onSelectedBillingDisussionPlan() {},
    async getEffectiveAcademicYears(admissionId) {
      await _getEffectiveAcademyYearsForAdmission(admissionId).then((resp) => {
        this.academicYearListIP = resp.data;
      });
    },
    async getThrapyDocTypeOther(academicYearId) {
      await _therapyDocTypeOther(academicYearId).then((resp) => {
        if (resp.data) {
          this.documentTypeList = resp.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.gray-box {
  border-radius: 5px;
  background-color: #f7f7f7;
}
.buttons-container {
  margin-top: 29px;
}
.message {
  font-size: 16px;
}
.big-icon {
  font-size: 3em;
}
.btn-dropdown-actions i.fa-angle-down {
  font-size: 12px;
  font-weight: 400;
}
.btn-dropdown-actions::after {
  border: none;
}
.swal2-styled {
  padding: 5px !important;
}
.dropdown-item {
  cursor: pointer;
  padding: 0.25rem 1rem;
  font-size: 15px;
}
.dropdown-item span {
  margin-left: 10px;
}
.dropdown-item em {
  min-width: 23px;
}
.list-enter,
.list-leave-to {
  display: none;
  height: 0;
}

.list-enter-active,
.list-leave-active {
  transition: height 0.35s ease;
}

.billing-text-label {
  text-align: left;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0px;
  color: #11291b;
}

.billing-text-span {
  text-align: left;
  font-size: 0.9rem;
  letter-spacing: 0px;
  color: #11291b;
}

.tag-badge-main-info span {
  background: none !important;
}
.custom-design {
  font-size: 25px;
  padding: 2px;
}
.color-icon-plus {
  color: #3f5b60 !important;
}
.container-design {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
}
</style>
<style>
.swal2-styled {
  padding: 4px !important;
}
</style>
